module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Bold.71eefe7ddfac289a12ce13a9d29ecc13.woff2";